var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.516,
    height: 47.3,
    viewBox: "0 0 40.516 47.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:none;stroke-miterlimit:10;stroke-width:2px;}.a,.c{stroke:#4f4f4f;}.b{stroke:#40b895;}.c{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M110.556,119.768a13.71,13.71,0,0,1-10.066-13.214V95.442a13.7,13.7,0,0,1,13.7-13.7h24.814v38.516h-22.98",
    transform: "translate(-100.49 -81.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M164.567,159.58h-7.68a1.561,1.561,0,0,1-1.557-1.557V135.157a1.561,1.561,0,0,1,1.557-1.557h7.68a1.561,1.561,0,0,1,1.557,1.557v22.864A1.561,1.561,0,0,1,164.567,159.58Z",
    transform: "translate(-148.177 -126.836)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 12.447,
    height: 11.418,
    transform: "translate(21.934 5.901)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 13.182,
    transform: "translate(21.483 21.664)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 13.182,
    transform: "translate(21.483 26.327)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 13.182,
    transform: "translate(21.483 30.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M202.117,341.237v2.687a2.707,2.707,0,0,1-2.7,2.7h0a2.707,2.707,0,0,1-2.7-2.7V334.26",
    transform: "translate(-184.168 -301.323)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandline);
export default __webpack_public_path__ + "static/media/landline.68447a19dec5f3668a6e0e3f0e822b90.svg";
export { ForwardRef as ReactComponent };